import { useContext } from 'react';
import { Content } from 'api';
import { ContentContext } from 'providers';

export default () => {
  // Hack to force type checker to accept the type of the context
  const content: Content = useContext(ContentContext);
  return content;
};
